// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QdIIrZWRq8s0nU22Ixsi{color:var(--content-negative-primary)}.JOgugmeZrcMKxRFgAsPr{gap:0;display:flex}.JOgugmeZrcMKxRFgAsPr>div{background:var(--background-primary-inverted-primary)}.JOgugmeZrcMKxRFgAsPr>div:nth-child(2){z-index:var(--zIndex-BASE_2);border-radius:50%;margin-left:-6px;box-shadow:0 0 0 1.5px #fff}.JOgugmeZrcMKxRFgAsPr>div:nth-child(3){z-index:var(--zIndex-BASE_3);border-radius:50%;margin-left:-6px;box-shadow:0 0 0 1.5px #fff}.JOgugmeZrcMKxRFgAsPr>div:nth-child(n+4){display:none}.yrHY6P9TZ8C299Mzth_4{align-items:center;gap:8px;height:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `QdIIrZWRq8s0nU22Ixsi`,
	"group": `JOgugmeZrcMKxRFgAsPr`,
	"box": `yrHY6P9TZ8C299Mzth_4`
};
export default ___CSS_LOADER_EXPORT___;
